/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    VerificationService,
    VerificationStepsEnum,
    FormFooterComponent,
} from '@sheerid/jslib';

const DOC_UPLOAD_POLL_DURATION = 20000;
const SSO_POLL_DURATION = 5000;

const defaultDocUploadSubtitle = 'SheerID is reviewing your documents, to confirm your status. <br><br> This process may take up to 20 minutes.';

const defaultDocUploadSubtitle2 = 'Wait here or let us notify you of the outcome. <br> You will be contacted via email.';

interface StepPendingProps {
    verificationService: VerificationService;
}

const StepPending = ({ verificationService }: StepPendingProps) => {
    const programId = verificationService.programId;
    const previousVerificationResponse = verificationService.previousVerificationResponse || undefined;
    const verificationId = verificationService.verificationResponse.verificationId;

    const isPreviousStepSSO = (): boolean => {
        if (previousVerificationResponse && previousVerificationResponse.currentStep === VerificationStepsEnum.sso) {
            return true;
        }
        return false;
    };

    const pollForVerificationServiceUpdates = () => setTimeout(
        () => {
            verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse);
        },
        isPreviousStepSSO() ? SSO_POLL_DURATION : DOC_UPLOAD_POLL_DURATION,
    );

    const timeout = pollForVerificationServiceUpdates();

    return (
        <div id="sid-step-pending" className="sid-l-container">
            <div className="sid-header sid-l-horz-center">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.pending.title" defaultMessage="PROCESSING" />
                </div>
                <div className="sid-header__subtitle-one">
                    <FormattedHTMLMessage
                        id="step.pending.subtitle"
                        defaultMessage={defaultDocUploadSubtitle}
                    />
                </div>
                <div className="sid-header__subtitle-two sid-l-space-top-md">
                    <FormattedHTMLMessage
                        id="step.pending.subtitle2"
                        defaultMessage={defaultDocUploadSubtitle2}
                    />
                </div>
            </div>
            <div className="sid-form-region sid-submit-wrapper sid-l-space-top-md">
                <div className="sid-submit">
                    <button
                        id="sid-submit-btn-collect-info"
                        type="submit"
                        onClick={() => window.open('https://www.levi.com/')}
                        className="sid-btn sid-btn--dark sid-l-full-width"
                        aria-label="submit"
                    >
                        <FormattedHTMLMessage id="continueToLevis" defaultMessage="CONTINUE TO LEVI'S" />
                    </button>
                </div>
            </div>

            <FormFooterComponent verificationService={verificationService} />
        </div>
    );
};

export const StepPendingComponent = injectIntl(StepPending);
